export default "__VITE_ASSET__ad58d5fd__"